
import { Options, mixins } from "vue-class-component";
import { FooterConfigState } from '@/constant/computerType'
import { JumpLink } from '@/mixins/JumpLink'
import { store } from '@/store'


@Options({
  name: 'PortalFooter',
  props: {
    footerData: {
      type: Object,
      required: true
    }
  }
})
export default class PortalFooter extends mixins(JumpLink) {
  private footerData: FooterConfigState = {
    default_name: 'default',
    basecolor: '',
    template_list: {
      default: {
        copyright: ''
      },
      template1: {
        copyright: '',
        nav_lists: []
      },
      template2: {
        copyright: '',
        qq_url: '',
        sina_url: '',
        wechat_img: '',
        show_qq: false,
        show_sina: false,
        show_wechat: false,
        text1: '',
        text2: ''
      }
    }
  };

  get isMobile() {
    return store.state.portal.isMobile
  }

  get currentData() {
    const currentData = this.footerData;
    if(currentData.default_name) {
      return currentData.template_list[currentData.default_name]
    }
    return {
      copyright: ''
    }
  }
}
